<template>
<div class="UserInfo">
    <div class="title_box">基本信息</div>
    <div class="input_box">
        <van-cell-group>
            <van-cell clickable :title="`头像`">
                <div class="uploader_head_portrait_box">
                    <van-uploader :max-count="9" :after-read="afterRead" :before-read="imgBeforeRead">
                        <img class="uploader_img_icon" :src="userheadimgurl" alt="">
                    </van-uploader>
                    <img class="icon_img" :src="require('@/common/images/mmy/icon-arrow-right2.png')" alt="">
                </div>
            </van-cell>
            <van-field v-model="userInfoData.nickname" label="昵称" placeholder="请填写" input-align="right" />
            <van-cell clickable :title="`性别`" @click="toggle()">
                <p style="color: #333;">{{userInfoData.sextext}}</p>
            </van-cell>
            <van-field class="Self_introduction" label="个人介绍" v-model="userInfoData.desp" rows="3" type="textarea" maxlength="200" placeholder="请填写" show-word-limit />
        </van-cell-group>
    </div>
    <div class="title_box">联系信息</div>
    <div class="input_box">
        <van-field v-model="userInfoData.name" label="真实姓名" placeholder="请填写" input-align="right" />
        <van-field v-model="userInfoData.email" label="常用邮箱" placeholder="请填写" input-align="right" />
        <van-field v-model="userInfoData.mobileno" label="手机号码" placeholder="请填写" type="tel" maxlength="11" input-align="right" />
        <van-field v-model="userInfoData.qq" label="QQ号码" placeholder="请填写" type="digit" input-align="right" />
    </div>
    <div class="select_sex_box">
        <van-action-sheet v-model="selectSexPop" :actions="actions" @select="onSelect" cancel-text="取消" />
    </div>
    <div class="save_btn_box">
        <van-button @click="saveUserInfoBtn" type="info">保存</van-button>
    </div>
</div>
</template>

<script>
import {getUserCustomerInfo, updateUserCustomerInfo, getUploadParam} from 'api/personalCenterApi'
import {Toast} from 'vant'
import axios from 'axios'
import {mapActions, mapGetters} from 'vuex'
export default {
    name: 'UserInfo',
    metaInfo: {
        title: '个人信息'
    },
    data() {
        return {
            selectSexPop: false,
            actions: [
                {name: '男'},
                {name: '女'}
            ],
            userheadimgurl: '',
            userInfoData: {
                headimgurl: '',
                nickname: '',
                mobileno: '',
                sex: '',
                sextext: '',
                desp: '',
                name: '',
                emai: '',
                qq: '',
                wxno: '',
            },
            uploadType: {
                catecode: '93',
                datatype: 'IMAGE'
            },
            fileOtherInfo: {
                keyid: '',
                vsource: 1,
                furl: ''
            }
        }
    },
    mounted() {
        this.findUserCustomerInfo()
    },
    activated() {},
    methods: {
        findUserCustomerInfo() {
            this.setLoading(true)
            getUserCustomerInfo({
                data: {},
                success: data => {
                    this.setLoading(false)
                    this.userheadimgurl = data.data.headimgurl
                    this.userInfoData = data.data
                    this.userInfoData.headimgurl = ''
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        saveUserInfoBtn() {
            this.setLoading(true)
            updateUserCustomerInfo({
                data: Object.assign({}, this.userInfoData),
                success: data => {
                    this.setLoading(false)
                    if (data) {
                        let user = Object.assign({}, this.user)
                        user.nickname = this.userInfoData.nickname
                        user.logourl = this.userheadimgurl
                        this.setUser(user)
                        window.sessionStorage.setItem('user', JSON.stringify(user))
                        window.history.back()
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$toast.fail(data.msg)
                }
            })
        },
        onSelect(item) {
            this.selectSexPop = false
            this.userInfoData.sextext = item.name
            if (this.userInfoData.sextext === '男') {
                this.userInfoData.sex = 1
            } else {
                this.userInfoData.sex = 2
            }
        },
        toggle() {
            this.selectSexPop = true
        },
        imgBeforeRead(file) {
            if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
                Toast('请上传 jpg/png/gif 格式图片')
                return false
            }
            let isLt1M = file.size / 1024 / 1024 <= 10
            if (!isLt1M) {
                Toast('图片大小10M以内')
                return false
            }
            return true
        },
        afterRead(file) {
            this._getUploadParam(file.file)
        },
        _getUploadParam(file) {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadImg(file)
                },
                error: data => {
                    this.$toast.fail(data.msg)
                    this.setLoading(false)
                }
            })
        },
        uploadImg (file) {
            this.showImgProBar = true
            const axiosInstance = axios.create({withCredentials: false})
            let formData = new FormData()
            formData.append('file', file)
            formData.append('key', this.uploadSetting.uploadfilekey)
            formData.append('token', this.uploadSetting.uploadauth)
            this.setLoading(true)
            axiosInstance({
                method: 'POST',
                url: this.uploadSetting.uploadurl,
                data: formData,
                timeout: 30000,
            }).then(data => {
                data = JSON.parse(data.request.response)
                this.imgsListFn(Object.assign({}, data, this.fileOtherInfo))
                this.setLoading(false)
            }).catch(data => {
                this.$toast.fail(data.msg)
                this.setLoading(false)
            })
        },
        imgsListFn(file) {
            var imgFile = JSON.stringify(file)
            this.userheadimgurl = file.furl
            this.userInfoData.headimgurl = imgFile
        },
        ...mapActions(['setLoading', 'setUser', 'setRefresh'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters(['user'])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.UserInfo {
    min-height: 100vh;
    padding-bottom: 1.2rem;
    box-sizing: border-box;
    background-color: pink;
    font-family:PingFangSC-Regular,PingFang SC;
    background-color: #F5F7FA;
    .title_box {
        height: 0.96rem;
        line-height: 0.96rem;
        font-size: 0.28rem;
        color: #999;
        padding-left: 0.32rem;
    }
    .input_box {
        .van-cell__title {
            display: flex;
            align-items: center;
        }
        .uploader_head_portrait_box {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            height: 1rem;
            .uploader_img_icon {
                width: 1rem;
                height: 1rem;
                border-radius: 1rem;
            }
            .icon_img {
                width: 0.16rem;
                height: 0.3rem;
                margin-left: 0.2rem;
            }
        }
        .Self_introduction {
            display: flex;
            flex-direction: column;
        }
        .van-cell {
            padding: 0.26rem 0.32rem;
            .van-cell__title {
                color: #666;
            }
        }
    }
    .select_sex_box {
        .van-popup--bottom.van-popup--round {
            border-radius: 0;
        }
    }
    .save_btn_box {
        background-color: #fff;
        box-shadow: 0 -0.02rem 0.1rem 0 rgba(216,220,230,0.57);
        width: 100vw;
        height: 1rem;
        position: fixed;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        .van-button--info {
            width: 6.86rem;
            height: 0.7rem;
            line-height: 0.7rem;
            border-radius: 1rem;
            font-size: 0.3rem;
            background-color: #409EFF;
            border-color: #409EFF;
        }
    }
}
</style>